import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ReactTypingEffect from 'react-typing-effect';
import hero1 from "../../images/slider/slide-1.jpg";
import "../../css/hero.css";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Hero = () => {
  useEffect(() => {
    const elements = document.querySelectorAll('.fade-in');
    elements.forEach((element, index) => {
      element.style.animation = `fadeIn 1s ease-in ${index * 0.3}s forwards`;
    });
  }, []);

  return (
    <section className="hero-slider hero-style-1">
      <div
        className="slide-inner slide-bg-image"
        style={{ 
          backgroundImage: `url(${hero1})`,
          position: 'relative',
        }}
      >
        <div className="overlay" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="slide-title fade-in">
            <h1 className="main-title">Welcome to Roslindale Food Collective</h1>
            <div className="animated-text">
              <h2>
                We deliver hope through{' '}
                <ReactTypingEffect
                  text={['groceries', 'compassion', 'community', 'dignity', 'care', 'solidarity']}
                  speed={100}
                  eraseSpeed={100}
                  eraseDelay={2000}
                  typingDelay={1000}
                  displayTextRenderer={(text) => {
                    return (
                      <span className="typed-text">{text}</span>
                    );
                  }}
                />
              </h2>
            </div>
          </div>
          <div className="slide-btns fade-in">
            <Link 
              onClick={ClickHandler} 
              to="/donate" 
              className="donate-button"
            >
              Donate Now <i className="fi flaticon-heart-1"></i>
            </Link>
          </div>
        </div>
      </div>
      <div className="social fade-in">
        <ul>
          <li>
            <a
              href="https://www.facebook.com/rosifoodcollective"
              target="_blank"
              rel="noopener noreferrer"
              onClick={ClickHandler}
              className="social-link"
            >
              <i className="ti-facebook"></i>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Hero;
